import PromoCodeAdmin from "../views/promoCode/PromoCode"


var routes = [
    {
        path: '/promo-code',
        name: "PromoCodeAdmin",
        component: PromoCodeAdmin
    }
]

export default routes